import { ActionTypes } from "@/App/constants/actionTypes";
import { UserPermissionsTypes } from "@/types";

type GetUserPermissionsAction = {
  type: typeof ActionTypes.GET_USER_PERMISSIONS;
};

export const getUserPermissions = (): GetUserPermissionsAction => {
  return {
    type: ActionTypes.GET_USER_PERMISSIONS,
  };
};

type GetUserPermissionsResultsAction = {
  type: typeof ActionTypes.GET_USER_PERMISSIONS_RESULTS;
  payload: UserPermissionsTypes.UserActions;
};

export const getUserPermissionsResults = (data: UserPermissionsTypes.UserActions): GetUserPermissionsResultsAction => {
  return {
    type: ActionTypes.GET_USER_PERMISSIONS_RESULTS,
    payload: data,
  };
};

export type GetUserPermissionsActions = GetUserPermissionsAction | GetUserPermissionsResultsAction;
